import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';

/**
 * Keeps the repo's icon convention: `<mat-icon>` carries `.material-icons`, and
 * `.material-symbols-outlined` means a bare glyph span. Both render the same font — abook-ui's
 * `_material-icons.scss` styles `.mat-icon` directly.
 *
 * Material 22 otherwise infers the default from `document.fonts`. Every app loads
 * 'Material Symbols Outlined', so mat-icons would get `.material-symbols-outlined` and pick up rules
 * written for glyph spans (the portal's dialog close icon shrank from 24px to 20px). The server has
 * no `document.fonts`, so it would also infer differently from the browser it hydrates in.
 */
export function provideIconFontSet(): EnvironmentProviders {
  return provideAppInitializer(() => {
    inject(MatIconRegistry).setDefaultFontSetClass('material-icons', 'mat-ligature-font');
  });
}
